import { useQuery } from '@tanstack/react-query';
import { getAllSettings } from '@services/settings';

export const SETTINGS_VERSION_QUERY_KEY = ['settings', 'version'];

export const useGetVersion = () => {
  return useQuery({
    queryKey: SETTINGS_VERSION_QUERY_KEY,
    queryFn: async () => {
      const response = await getAllSettings();
      const minVersionSetting = response.settings.find(
        (s) => s.name === 'minVersion',
      );
      // Return in old format for backward compatibility
      return {
        getVersion: minVersionSetting ? [minVersionSetting] : [],
      };
    },
    staleTime: 5 * 60 * 1000,
  });
};

export default useGetVersion;
